import AuthService from './authService';

class ApiWrapper {
  private authService: AuthService;

  constructor(authService: AuthService) {
    this.authService = authService;
  }

  // Метод для обновления конфигурации (например, при изменении токена)
  updateConfig(): void {
    this.authService.setAuthHeaders();
  }
}

// Создаем глобальный экземпляр ApiWrapper
const apiWrapper = new ApiWrapper(new AuthService());

export default apiWrapper;
export { ApiWrapper };
